import { PAGE_LINKS } from './commonConsts'

class EnvHelper {
  get extensionPrefix() {
    return 'home_site'
  }

  get isProd() {
    return process.env.NODE_ENV === 'production'
  }

  get productName() {
    return '官网'
  }

  get host() {
    return process.env.REACT_APP_HOST
  }

  get webHost() {
    return process.env.REACT_APP_WEB_HOST
  }

  get apiHost() {
    return this.webHost
  }

  get apiBasePath() {
    return '/byy/homesite_server'
  }

  get wxAppId() {
    return process.env.REACT_APP_WX_APPID
  }

  get wxLoginScope(): 'snsapi_userinfo' | 'snsapi_base' {
    return 'snsapi_userinfo' // snsapi_base 或 snsapi_userinfo
  }

  get wxAuthorizeUrl() {
    if (window.location.hostname !== PAGE_LINKS.wxLogin) {
      sessionStorage.setItem('login_back_url', window.location.href)
    }

    // const url = encodeURIComponent(`${this.webHost}${PAGE_LINKS.wxLogin}`)
    const url = encodeURIComponent(window.location.href)
    const newurl = new URL(window.location.href)
    const searchParams = newurl.searchParams
     if(searchParams.get('code')){
      searchParams.delete('code')
    }
    const newUrl = encodeURIComponent(newurl.toString())
    console.log('newUrl',newUrl)
    return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.wxAppId}&redirect_uri=${newUrl}&response_type=code&scope=${this.wxLoginScope}&state=0#wechat_redirect`
  }

  get cdn() {
    return 'https://d.1yb.co'
  }
}

export const envHelper = new EnvHelper()
